/*global
    module
*/
(function (root, factory) {
    'use strict';

    if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.aap = root.aap || {};
        // aap.stringformat('{0} {1}', 'hello', 'world') // returns 'hello world'
        root.aap.stringformat = factory();
    }
}(this, function () {

    'use strict';

    return function(format) {
        var args = Array.prototype.slice.call(arguments, 1);

        return format.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] !== 'undefined' ? args[number] : match;
        });
    };
}));
